/**
 * Shortcut functions that tell you which page you're on
 */
export function isWooCommerceCartPage() {
  return document.querySelector('body').classList.contains('woocommerce-cart');
}

export function isWooCommerceCheckoutPage() {
  return document.querySelector('body').classList.contains('woocommerce-checkout');
}
